export default __webpack_public_path__ + "static/media/bathroom2-afterA-1024w.8bccd9cf.png";